module.exports = __webpack_public_path__ + "img/Logo_full_bleed.c9876c9b.jpg";